import React from 'react';
import ReactTimeAgo from 'react-time-ago';
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
import { useDispatch, useSelector } from 'react-redux';
import { markAsReadNotification } from '../../store/reducers/uiReducer';
import { RegularIcon } from '../common/icons/RegularIcon';

export const ToastNotifications = () => {
    const dispatch = useDispatch();
    const { notifications } = useSelector((state) => state.ui);

    const handleClose = (id) => {
        dispatch(markAsReadNotification({ id }));
    };

    return (
        <ToastContainer containerPosition="fixed" position="bottom-end" className="p-3">
            {notifications
                .filter((item) => !item.read)
                .map(({ id, type, icon, title, date, message }) => (
                    <Toast
                        key={id}
                        onClose={() => handleClose(id)}
                        animation={true}
                        autohide={true}
                        delay={5000}>
                        <Toast.Header>
                            <strong className="me-auto">
                                <RegularIcon icon={icon} color={type} className="me-2" />
                                {title}
                            </strong>
                            <small className="text-muted">
                                <ReactTimeAgo date={Date.parse(date)} timeStyle="round" />
                            </small>
                        </Toast.Header>
                        <Toast.Body>{message}</Toast.Body>
                    </Toast>
                ))}
        </ToastContainer>
    );
};
